<template>
  <v-container>
    <v-app-bar color="transparent" class="page-header-toolbar">
      <h2 class="page-title">{{ $t("checklist.forms") }}</h2>

      <v-spacer></v-spacer>

      <div class="page-filter mr-3">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field v-model="search" :label="$t('global.search')" hide-details clearable autocomplete="new-password"></v-text-field>
          </v-flex>
        </v-layout>
      </div>

      <action-button type="new" @click="getSingleRecordHandler()" />
    </v-app-bar>

    <!--<data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>-->

    <v-data-table
      :loading="loadingForms"
      :loading-text="$t('global.loading_text')"
      :no-data-text="$t('global.no_data_text')"
      :no-results-text="$t('global.no_data_text')"
      :headers="headers"
      :items="forms"
      :items-per-page.sync="items_per_page"
      :search="search"
      :footer-props="{
        'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
        'items-per-page-all-text': $t('global.items_per_page_all_text'),
        'items-per-page-text': $t('global.items_per_page_text'),
        'page-text': $t('global.page_text')
      }"
      :must-sort="true"
    >
      <template v-slot:item.checklist_type="{ item }">
        {{ $dd_checklisttemplate_checklist_type(item.checklist_type) }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ $dd_checklisttemplate_checklist_status(item.status) }}
      </template>
      <template v-slot:item.updated_at="{ item }">
        {{ item.updated_at ? moment(item.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
      </template>
      <template v-slot:item.actions="{ item }">
        <action-button type="edit" :icon_only="true" small @click="getSingleRecordHandler(item.id)" v-if="$can('checklisttemplate-edit')" />
        <action-button type="download" :icon_only="true" small @click="downloadPDF(item.id)" v-if="$can('checklisttemplate-access')" />
        <action-button type="delete" @click="deleteRecord(item.id)" :icon_only="true" small v-if="$can('checklisttemplate-delete')" />
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
      <v-progress-linear :active="loading" :indeterminate="loading" color="primary"></v-progress-linear>
      <form-builder :formProp="formProp" v-if="dialog" @update="saveFormData" @closeForm="closeDialogHandler"> </form-builder>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue"
import VueCookie from "vue-cookie"
import format from "@/plugins/formatters"
import api from "@/plugins/api_services"
import validations from "@/mixins/validations"
import DataList from "@/mixins/components/DataList.vue"
import { checklistModules, checklistStatuses, checklistTypes, checklistFormulaType } from "@/utils/support_list"
import { checklistApi } from "@/plugins/api_settings"
import rowsPerPage from "@/mixins/rowsPerPage"

const plugins = { format, VueCookie, api }
Object.keys(plugins).forEach((key) => {
  Vue.use(plugins[key])
})
Vue.mixin(validations)

export default {
  name: "forms",
  mixins: [rowsPerPage],
  data() {
    return {
      search: "",
      loading: false,
      dialog: false,
      payload: {
        from: "forms",
        propid: 0
      },
      formProp: {
        id: null,
        is_active: true,
        checklist_type: 2
      },
      listOfChecklistModule: checklistModules,
      listOfChecklistStatus: checklistStatuses,
      listOfChecklistType: checklistTypes,
      listOfChecklistFormulaType: checklistFormulaType,

      forms: [],
      loadingForms: false
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t("checklisttemplate.title"), value: "title" },
        {
          text: this.$t("checklisttemplate.checklist_type"),
          value: "checklist_type"
        },
        { text: this.$t("checklisttemplate.status"), value: "status" },
        { text: this.$t("checklisttemplate.updated_on"), value: "updated_at" },
        {
          text: this.$t("global.actions"),
          value: "actions",
          width: "160px",
          align: "end",
          sortable: false
        }
      ]
    }
  },
  components: {
    DataList,
    "form-builder": () => import("@/mixins/components/checklist/builder/Index.vue")
  },
  watch: {
    pagination: {
      handler(val) {
        this.getListHandler()
      },
      deep: true
    }
  },
  created() {
    this.getListHandler()
  },
  methods: {
    getListHandler() {
      this.loadingForms = true
      axios
        .get(this.API_URL + `checklist-template`)
        .then((response) => {
          if (response.status == 200) {
            this.forms = response.data.data
          }
        })
        .catch((error) => {
          this.$handleServerSideError(error)
        })
        .then(() => {
          this.loadingForms = false
        })
    },
    openDialogHandler() {
      this.dialog = true
      this.formProp = { id: null, form_id: null, is_active: true }
    },
    closeDialogHandler() {
      this.dialog = false
      this.formProp = {
        id: null,
        is_active: true
      }
    },
    async getSingleRecordHandler(id = null) {
      if (id) {
        await axios
          .get(this.API_URL + `checklist-template/${id}`)
          .then((response) => {
            if (response.status == 200) {
              let data = response.data.data
              this.formProp = data
              this.formProp.id = data.id
              this.formProp.name = data.title
              this.formProp.status = data.status
              this.formProp.form_id = data.checklist_template_api_id
            }
          })
          .catch((error) => {
            this.$handleServerSideError(error)
          })
      }

      this.dialog = true
    },
    saveFormData(payload) {
      if (payload.status === "success") {
        let text = ""
        if (payload.data) {
          if (payload.action === "update") text = this.$t("checklistapi.common.updatedSuccess")
          else if (payload.action === "add") {
            text = this.$t("checklistapi.common.addedSucess")
            this.closeDialogHandler()
            window.location.reload(true)
          }
        }
        this.$awn.success(text)
        if (payload.type === "UPDATE_CLOSE") this.closeDialogHandler()
        this.getListHandler()
      } else if (payload && payload.status === "error" && payload.data) {
        this.$awn.alert(JSON.stringify(payload.data))
      }
    },
    deleteRecord(id) {
      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "checklist-template/" + id)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.status == "error") {
                  this.$awn.alert(response.data.message)
                  return
                }
                this.getListHandler()
                this.$awn.success(
                  this.$t("global.delete_success", {
                    module: this.$t("checklisttemplate.module")
                  })
                )
              }
            })
            .catch((error) => {
              this.$handleServerSideError(error)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    downloadPDF(id) {
      axios({
        url: this.API_URL + "checklist-template/download/" + id,
        method: "POST",
        responseType: "arraybuffer"
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const filename = "Checklist_Template_" + this.moment().format("YYYYMMDDHHmmss") + ".pdf"
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", filename)
            link.click()
          }
        })
        .catch((error) => {
          this.$handleServerSideError(error)
        })
    }
    // getChecklistType(type_id){
    //   let types = this.$dd_checklisttemplate_checklist_type();
    //   let type = types.find(o => o.key == type_id );
    //   return type.text;
    // }
  }
}
</script>
